import { StarSolid } from '@awazevr/design-system.components.icon'
import { Stack } from '@awazevr/design-system.components.stack'
import { Text } from '@awazevr/design-system.components.text'

import {
  StyledStarRatingContainer,
  StyledStarRatingValue,
} from './StarRating.styles'

const TOTAL_STARS = 5

export type StarRatingProps = {
  grade: number
  label?: string
  outOfLabel?: string
  idPrefix?: string
}

export const StarRating = ({
  grade,
  label = 'Grade',
  outOfLabel = 'out of 5',
  idPrefix = 'grade-star',
}: StarRatingProps): JSX.Element | null => {
  if (!grade || grade <= 0) return null

  const stars = Array.from({ length: TOTAL_STARS })
  const filledStars = Math.min(Math.max(Math.round(grade), 0), TOTAL_STARS)

  return (
    <div>
      <Text sizes={100} type="mid" mb={4}>
        {label}
      </Text>
      <StyledStarRatingContainer
        role="img"
        aria-label={`${label}: ${grade} ${outOfLabel}`}
      >
        <Stack direction="row" spacing={4} align={'center'}>
          {stars.map((_, index) => (
            <StarSolid
              key={`${idPrefix}-${index}`}
              iconColour={
                index < filledStars ? 'ColorThemeAccent2' : 'ColorGrey200'
              }
              size="x-small"
            />
          ))}
          <StyledStarRatingValue aria-hidden="true">
            <strong>{grade}</strong>/5
          </StyledStarRatingValue>
        </Stack>
      </StyledStarRatingContainer>
    </div>
  )
}
